import { IS_INSET_DESIGN_ENABLED } from '@/components/constants/flags';
import { useIsMobile } from '@/hooks/useWindowDimensions';
import { cn } from '@/lib/cn';
import { HeidiLogoMark } from '@heidi/design-system/heidi-logo-mark';
import { Sheet, SheetTrigger } from '@heidi/design-system/sheet';
import { useAtom } from 'jotai';
import { AlignJustify } from 'lucide-react';
import { useRouter } from 'next/router';
import { memo, useCallback } from 'react';
import { isMobileHeaderSheetOpenAtom } from './mobile-header-sheet-atoms';
import MobileHeaderSheetContent from './mobile-header-sheet-content';

const IntegrationMobileAppHeader = memo(() => {
  const isMobile = useIsMobile();
  const router = useRouter();

  const [isMobileHeaderSheetOpen, setIsMobileHeaderSheetOpen] = useAtom(
    isMobileHeaderSheetOpenAtom
  );

  const toggle = useCallback(() => {
    if (isMobile) {
      setIsMobileHeaderSheetOpen(!isMobileHeaderSheetOpen);
    }
  }, [isMobile, setIsMobileHeaderSheetOpen, isMobileHeaderSheetOpen]);

  return (
    <div>
      <Sheet open={isMobileHeaderSheetOpen} onOpenChange={toggle}>
        <div
          className={cn(
            'flex w-full flex-col gap-4 px-4 pb-3 pt-1 sm:hidden',
            IS_INSET_DESIGN_ENABLED() ? 'bg-surface-shell' : 'bg-surface-page'
          )}
        >
          <div className={'flex flex-col gap-2'}>
            <div className="flex w-full flex-row items-center justify-between gap-3">
              <SheetTrigger data-testid="sidebar-mobile-burger">
                <AlignJustify size="24" />
              </SheetTrigger>
              {isMobile && router.pathname.startsWith('/integrations') && (
                <>
                  <HeidiLogoMark className="size-4" aria-label="Heidi" />
                  <div className="size-6"></div>
                </>
              )}
            </div>
          </div>
        </div>
        <MobileHeaderSheetContent />
      </Sheet>
    </div>
  );
});

IntegrationMobileAppHeader.displayName = 'IntegrationMobileAppHeader';
export default IntegrationMobileAppHeader;
